/* DD No-Salt "what's inside" sheet, v2. One quiet entry point opens a native <dialog> (bottom sheet on a phone, card on
   desktop) that starts on an overview: Jon's video, then the ingredient list. Tap an ingredient for its detail, with
   prev/next and a way back. showModal() provides the focus trap, inert page and aria-modal; this adds animated close,
   Esc, backdrop tap, scroll lock, focus return and the lazy video. The video is given its src when the sheet opens and has
   preload="none", so no video bytes are fetched until someone presses play. No autoplay. Idempotent per section,
   re-wired on shopify:section:load. */
(function () {
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FOCUSABLE = 'a[href],button:not([disabled]),video[controls],[tabindex]:not([tabindex="-1"])';

  function wire(sec) {
    if (sec.dataset.ddnsSheetWired) return;
    var dlg = sec.querySelector('dialog.ddns-sheet');
    if (!dlg) return;
    sec.dataset.ddnsSheetWired = '1';

    var items = [].slice.call(dlg.querySelectorAll('[data-ing]'));
    var vOver = dlg.querySelector('[data-view="overview"]');
    var vDet = dlg.querySelector('[data-view="detail"]');
    var video = dlg.querySelector('video');
    var kick = dlg.querySelector('[data-k]'), nm = dlg.querySelector('[data-n]'), tx = dlg.querySelector('[data-t]'), ct = dlg.querySelector('[data-c]');
    var closeBtn = dlg.querySelector('[data-close]');
    var idx = 0, opener = null, closing = false;

    function lock(on) { document.documentElement.classList.toggle('ddns-lock', on); }
    function fill(i) {
      idx = (i + items.length) % items.length;
      var c = items[idx];
      kick.textContent = c.getAttribute('data-group') || '';
      nm.textContent = c.getAttribute('data-name') || '';
      tx.textContent = c.getAttribute('data-text') || '';
      ct.textContent = (idx + 1) + ' / ' + items.length;
    }
    function show(mode, focusTarget) {
      var det = mode === 'detail';
      vOver.hidden = det;
      vDet.hidden = !det;
      dlg.setAttribute('data-mode', mode);
      if (det && video) { try { video.pause(); } catch (e) {} }
      var panel = dlg.querySelector('.ddns-sheet__panel'); if (panel) panel.scrollTop = 0;
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }
    function open(from) {
      opener = from || document.activeElement;
      closing = false;
      if (video && !video.getAttribute('src') && video.getAttribute('data-src')) video.setAttribute('src', video.getAttribute('data-src'));
      show('overview');
      if (!dlg.open) {
        if (typeof dlg.showModal === 'function') dlg.showModal();
        else { dlg.setAttribute('open', ''); dlg.setAttribute('aria-modal', 'true'); }
      }
      lock(true);
      requestAnimationFrame(function () { dlg.classList.add('is-open'); });
      (closeBtn || dlg).focus({ preventScroll: true });
    }
    function close() {
      if (closing || !dlg.open) return;
      closing = true;
      if (video) { try { video.pause(); } catch (e) {} }
      dlg.classList.remove('is-open');
      setTimeout(function () {
        if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
        lock(false);
        if (opener && opener.focus) opener.focus({ preventScroll: true });
        closing = false;
      }, RM ? 0 : 240);
    }

    sec.querySelectorAll('[data-open]').forEach(function (b) { b.addEventListener('click', function () { open(b); }); });
    items.forEach(function (c, i) { c.addEventListener('click', function () { fill(i); show('detail', closeBtn); }); });
    dlg.querySelectorAll('[data-back]').forEach(function (b) {
      b.addEventListener('click', function () { show('overview'); var t = items[idx]; if (t) t.focus({ preventScroll: false }); });
    });
    dlg.querySelector('[data-prev]').addEventListener('click', function () { fill(idx - 1); });
    dlg.querySelector('[data-next]').addEventListener('click', function () { fill(idx + 1); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (!vDet.hidden && e.key === 'ArrowRight') fill(idx + 1);
      if (!vDet.hidden && e.key === 'ArrowLeft') fill(idx - 1);
      if (e.key === 'Tab' && typeof dlg.showModal !== 'function') {
        var f = [].slice.call(dlg.querySelectorAll(FOCUSABLE)).filter(function (n) { return n.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    dlg.addEventListener('close', function () { lock(false); });
  }

  function init(scope) { (scope || document).querySelectorAll('[data-ddns-sheet-root]').forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
